<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start"
          >
            <v-date-picker
              v-model="query.searchDate"
              type="month"
              value-type="YYYYMM"
              class="el-def"
              style="width: 150px"
            />

            <!-- <v-select
              v-model="query.filterType"
              :options="codes.webResourceType"
              placeholder="웹 리소스 유형"
              :reduce="option => option.code"
              class="el-def"
              @change="refetchData()"
            /> -->

            <b-form-input
              v-model="query.filterStr"
              class="el-def"
              placeholder="이용 목적"
              @keyup.enter="refetchData()"
            />

          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              조회 된 리소스 [{{ totalRecords }}] 건
            </h5>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-primary"
              class="btn-search"
              @click.prevent="showWebResourceFileUploader = true"
            >
              <feather-icon
                icon="UploadIcon"
                class="mr-50"
              />
              <span>리소스 업로드</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refWebResourceTable"
        primary-key="id"
        :items="fetchWebResources"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        class="position-relative"
        style="max-height: 670px"
      >
        <template #cell(webResourceType)="data">
          <div
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
          >
            {{ getLabel(data.value, codes.webResourceType, '-') }}
          </div>
        </template>

        <template #cell(title)="data">
          <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ data.value }}
          </div>
        </template>

        <template #cell(filePath)="data">
          <span class="text-nowrap">
            <b-button
              variant="primary"
              @click="copyToClipboard(data.value)"
            >
              URL 복사
            </b-button>
          </span>
        </template>

        <template #cell(userName)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <template #cell(createDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD HH:mm') }}
          </span>
        </template>

      </b-table>
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="10"
        align="center"
      />
    </b-card>

    <web-resource-file-upload
      :show-web-resource-file-upload="showWebResourceFileUploader"
      @close="webResourceFileUploader.close"
    />
  </div>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import { BButton } from 'bootstrap-vue'
import { ref, watch, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  required, requiredIf, before, dateBetween,
} from '@validations'
import WebResourceFileUpload from './WebResourceFileUpload.vue'

export default {
  components: {
    WebResourceFileUpload,
    BButton,
  },
  setup() {
    onMounted(() => {
      fetchWebResourceType()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const cleave = ref({
      point: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        prefix: 'P',
        tailPrefix: true,
      },
      person: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      percent: {
        numeral: true,
        prefix: '%',
        tailPrefix: true,
      },
    })

    const showWebResourceFileUploader = ref(false)
    const webResourceFileUploader = {
      close: rs => {
        if (rs) {
          refetchData()
        }
        showWebResourceFileUploader.value = false
      },
    }

    // Set Codes
    const codes = ref({
      webResourceType: [],
      webResourceUsageType: [],
    })
    // Set Codes End.

    // Query Data
    const query = ref({
      filterType: null,
      filterStr: null,
      searchDate: dayjs().format('YYYYMM'),
    })
    // Query Data End.

    const getLabel = (findCode, codeSet, defaultLabel = '') => {
      const target = codeSet.find(x => x.code === findCode)
      return (target && target.label) ? target.label : defaultLabel
    }

    // Main Table Config
    const refWebResourceTable = ref(null)

    const sortBy = ref('createDate')
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'webResourceType', label: '리소스 유형', sortable: false, thStyle: { width: '10%' },
      },
      {
        key: 'title', label: '이용 목적', sortable: false,
      },
      {
        key: 'fileName', label: '파일명', sortable: false, thStyle: { width: '20%' },
      },
      {
        key: 'filePath', label: 'URL', sortable: false, thStyle: { width: '15%' },
      },
      {
        key: 'createUserName', label: '등록자', sortable: false, thStyle: { width: '10%' },
      },
      {
        key: 'createDate', label: '등록일시', sortable: false, thStyle: { width: '14%' },
      },
    ]

    // Fetch Data
    const refetchData = () => {
      query.value.searchDate = query.value.searchDate ? query.value.searchDate : dayjs().format('YYYYMM')
      refWebResourceTable.value.refresh()
    }

    watch([currPage], () => {
      refetchData()
    })

    const fetchWebResourceType = () => {
      axios.get(`/fa/web-resource/codes`)
        .then(rs => {
          codes.value.webResourceType = rs.data.webResourceType
          codes.value.webResourceUsageType = rs.data.webResourceUsageType
        })
        .catch(err => {
          console.log(err)
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const fetchWebResources = (ctx, callback) => {
      axios.post('fa/web-resource/list', {
        search: {
          filterType: query.value.filterType,
          filterStr: query.value.filterStr,
          searchDate: query.value.searchDate ? dayjs(query.value.searchDate).date(1).format('YYYY-MM-DD') : null,
        },
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data

          callback(items)

          totalRecords.value = totalRecord

          // resetWebResourceData()
        })
        .catch(err => {
          console.log(err)
          pushToast('danger', '데이터 목록 갱신에 실패하였습니다.')
        })
    }
    // Fetch Data End.

    const copyToClipboard = text => {
      if (!text) {
        this.pushToast('error', 'URL이 없습니다.')
        return
      }
      navigator.clipboard.writeText(text)
        .then(() => {
          pushToast('success', `URL이 클립보드에 복사되었습니다.`)
        })
        .catch(err => {
          console.log(err)
          pushToast('warning', `클립보드에 복사하는 동안 오류가 발생했습니다.`)
        })
    }

    return {
      query,
      codes,
      tableColumns,
      refWebResourceTable,
      sortBy,
      currPage,
      isSortDesc,
      required,
      requiredIf,
      before,
      dateBetween,
      refetchData,
      totalRecords,
      fetchWebResources,
      fetchWebResourceType,
      cleave,
      showWebResourceFileUploader,
      webResourceFileUploader,
      copyToClipboard,
      getLabel,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style>
#eventPreview .modal-dialog {
  max-width: 1304px;
}
</style>
